const statusUserChoice = [
    { id: 0, name: "Lead" },
    { id: 1, name: "Cadastrado" },
]

export default statusUserChoice;
